<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="shortcut icon" href="/favicon.ico" sizes="32x32" />
    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <meta name="apple-mobile-web-app-title" content="Mouse Over" />
    <link rel="manifest" href="/site.webmanifest" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>Mouse Over</title>
    <meta name="google" content="notranslate" />
  </head>
  <body>
    <div id="root"></div>

    <script>
      env = '${INJECT_ENV}';
    </script>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
